export default __webpack_public_path__ + "static/media/adobephotoshop.2af1cd0b.png";